import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

interface Props {
    count?: number;
    /** 다운로드 탭처럼 우측에 버튼이 있는 아이템 */
    withAction?: boolean;
}

function CouponItemSkeletons({ count = 5, withAction }: Props) {
    return (
        <Column fullWidth spacing={4} aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <Row key={`coupon-item-sk-${idx}`} fullWidth spacing={4} align='center'>
                    <Skeleton width={80} height={80} />
                    <Content spacing={1}>
                        <Skeleton width='40%' height={17} />
                        <Skeleton width='70%' height={22} />
                        <Skeleton width='60%' height={17} />
                    </Content>
                    {withAction && (<Skeleton width={32} height={32} shape='block' />)}
                </Row>
            ))}
        </Column>
    );
}

const Content = styled(Column)`
    flex: 1;
    min-width: 0;
`;

export default CouponItemSkeletons;
